"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _effects = require("redux-saga/effects");

var _normalizr = require("normalizr");

var _apiHelper = require("api/api-helper");

var _bookingSchema = require("api/schemas/bookingSchema");

var _bookingSchema2 = _interopRequireDefault(_bookingSchema);

var _bookingDataActions = require("actions/bookingDataActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchBookingData);

// Used for fetching data for the current booking, and subsequently
// it's linked bookings (see bookingDataActions.js)
function fetchBookingData() {
    var bookingId, authToken, locale, _ref, bookingData, error, _ref2, entities;

    return _regenerator2.default.wrap(function fetchBookingData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!true) {
                        _context.next = 33;
                        break;
                    }

                    _context.next = 3;
                    return (0, _effects.take)(_bookingDataActions.BOOKING_DATA_REQUESTED);

                case 3:
                    _context.next = 5;
                    return (0, _effects.select)(function (state) {
                        return state.booking.id;
                    });

                case 5:
                    bookingId = _context.sent;
                    _context.next = 8;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 8:
                    authToken = _context.sent;
                    _context.next = 11;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 11:
                    locale = _context.sent;
                    _context.next = 14;
                    return (0, _apiHelper.getBookingData)(bookingId, authToken, locale);

                case 14:
                    _ref = _context.sent;
                    bookingData = _ref.bookingData;
                    error = _ref.error;

                    if (!bookingData) {
                        _context.next = 29;
                        break;
                    }

                    _context.next = 20;
                    return (0, _effects.put)((0, _bookingDataActions.bookingDataReceived)(bookingData));

                case 20:
                    _context.next = 22;
                    return (0, _effects.call)(_normalizr.normalize, bookingData, _bookingSchema2.default);

                case 22:
                    _ref2 = _context.sent;
                    entities = _ref2.entities;

                    if (!(entities.linked_bookings && (0, _keys2.default)(entities.linked_bookings).length)) {
                        _context.next = 27;
                        break;
                    }

                    _context.next = 27;
                    return (0, _effects.put)((0, _bookingDataActions.linkedBookingsDataReceived)(entities.linked_bookings));

                case 27:
                    _context.next = 31;
                    break;

                case 29:
                    _context.next = 31;
                    return (0, _effects.put)((0, _bookingDataActions.bookingDataRequestFailed)(error));

                case 31:
                    _context.next = 0;
                    break;

                case 33:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchBookingData;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchBookingData.js
// module id = 1408
// module chunks = 0